/** The account's server-selected timezone defines its trading day. */
export function accountDayAt(timezone: string, now: number): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}
